import { Component, Input, OnInit, Inject, PLATFORM_ID, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { CartService } from '../_services/cart.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { AppConstants } from '../_constants/constants';
import { Offer, getPrice } from '../_models/offer';
import { User } from '../_models/user';
import { environment } from 'src/environments/environment';
import { TaxonomyService } from '../_services/taxonomy.service';
import { TaxonomyOffers } from '../_models/taxonomy-offers';
import { WishlistService } from '../_services/wishlist.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-taxonomy-offers',
    templateUrl: './taxonomy-offers.component.html',
    styleUrls: ['./taxonomy-offers.component.css'],
    standalone: false
})
export class TaxonomyOffersComponent implements OnInit {
    @Input() taxonomyId: number;
    @Input() title: string;
    @Input() layout: 'slider' | 'grid' = 'slider';
    @ViewChild('sliderContainer') sliderContainer: ElementRef;

    taxonomyOffers: TaxonomyOffers;
    offers: Offer[] = [];
    loadingState: boolean;
    totalOfItems = 0;

    defaultImage = '/assets/images/default.jpg';
    imageSrc: string;
    currentLanguage: string | null = null;
    user: User = null;

    constructor(
        private cartService: CartService,
        private toastService: ToastrService,
        private translateService: TranslateService,
        private taxonomyService: TaxonomyService,
        private wishlistService: WishlistService,
        private router: Router,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        this.loadingState = true;
        if (isPlatformBrowser(this.platformId)) {
            this.user = JSON.parse(localStorage.getItem('currentUser') ?? '{}');
        }
    }

    addProductToCart(offer: any) {
        this.cartService.addToLocalCart(offer).subscribe(
            () => {
                const addCartMessage = this.translateService.get('common.message_for_added_to_cart')
                    .subscribe(message => {
                        this.toastService.success(message);
                    });
            }
        );
    }

    addToWishlist(offer: any, event: Event): void {
        event.stopPropagation();
        event.preventDefault();

        if (!this.user || !this.user.id) {
            localStorage.setItem('pendingWishlistOfferId', offer.id.toString());
            this.router.navigate(['/signin'], {
                queryParams: { returnUrl: this.router.url }
            });
            return;
        }

        this.wishlistService.addToWishList(this.user.id, offer.id)
            .subscribe({
                next: () => {
                    this.translateService.get('common.message_for_added_to_wishlist')
                        .subscribe(message => {
                            this.toastService.success(message);
                        });
                },
                error: (error) => {
                    if (error.status === 409 || error.error?.message?.includes('already')) {
                        this.toastService.info('This item is already in your wishlist');
                    } else {
                        this.toastService.error('Failed to add to wishlist');
                    }
                }
            });
    }

    getImageSrc(offer: Offer) {
        return environment.image_cdn_url + '/' +
            (offer.defaultPicture.length > 0 ? offer.defaultPicture + '?func=crop&width=280&height=280' : offer.product.picture);
    }

    getOfferPrice(offer: Offer): number {
        return getPrice(offer);
    }

    slideConfig = {
        autoplay: false,
        infinite: true,
        dots: false,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 2,
        centerMode: false,
        prevArrow: "<button class='slide-arrow prev-arrow'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
        nextArrow: "<button class='slide-arrow next-arrow'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ]
    }

    slickInit() {}
    breakpoint() {}
    afterChange() {}
    beforeChange() {}

    navigateToProduct(offer: Offer): void {
        this.router.navigate(['products', offer.product.name.replace(' ', '-'), offer.id]);
    }

    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.currentLanguage = localStorage.getItem(AppConstants.CURRENT_LANG_STORE_KEY);
        }
        this.taxonomyService.getTaxonomyOffers(this.taxonomyId, 1, 18)
            .subscribe(
                (response: TaxonomyOffers) => {
                    this.taxonomyOffers = response;
                    this.offers = response.data;
                    this.loadingState = false;
                }
            )
    }

}
